import type { InputHTMLAttributes, ReactNode } from "react";

/** The canvas sign-in backdrop: coral with the CLIQ SUITE wordmark, the form in a white card on the right. */
export function AuthFrame({ children, wide = false }: { children: ReactNode; wide?: boolean }) {
  return (
    <div className="o-auth">
      <div className="o-auth__word" aria-hidden="true">
        CLIQ
        <br />
        SUITE
        <span className="o-auth__product">BUSINESS</span>
      </div>
      <div className="o-auth__pitch">
        <div className="o-auth__line">One platform for every counter you run.</div>
        <ul>
          <li><span className="ms" aria-hidden="true">check_circle</span>Switch modules on per store, pay for what you use</li>
          <li><span className="ms" aria-hidden="true">check_circle</span>Every location rolls up into one view</li>
          <li><span className="ms" aria-hidden="true">check_circle</span>Live sync to your registers and kitchen screens</li>
        </ul>
      </div>
      <main className={`o-auth__card${wide ? " is-wide" : ""}`}>{children}</main>
    </div>
  );
}

export function AuthHead({ title, sub, icon, tone = "coral" }: { title: string; sub?: ReactNode; icon?: string; tone?: "coral" | "ok" | "amber" }) {
  return (
    <div>
      {icon && (
        <span className={`o-auth__icon is-${tone}`}>
          <span className="ms" aria-hidden="true">{icon}</span>
        </span>
      )}
      <h1 className="o-auth__title">{title}</h1>
      {sub && <p className="o-auth__sub">{sub}</p>}
    </div>
  );
}

/** Label, leading icon and input in the canvas field style. */
export function IconField({ label, icon, ...input }: { label: string; icon?: string } & InputHTMLAttributes<HTMLInputElement>) {
  return (
    <label className="o-ifield">
      <span className="o-field__label">{label}</span>
      <span className="o-ifield__box">
        {icon && <span className="ms" aria-hidden="true">{icon}</span>}
        <input aria-label={label} {...input} />
      </span>
    </label>
  );
}
